import { SupabaseClient } from "@supabase/supabase-js";

// Walks any chain of merges server-side (see the migration) to the final live patient, returning
// that patient's mrn (the patient drawer route is keyed by mrn, not id) — null if patientId was
// never archived by a merge.
const getPatientMergeTarget = async (
  supabase: SupabaseClient,
  patientId: string,
): Promise<string | null> => {
  const { data, error } = await supabase.rpc("get_patient_merge_target_mrn", {
    p_patient_id: patientId,
  });

  if (error) throw new Error(error.message);

  return data ?? null;
};

export default getPatientMergeTarget;
